import { useContext } from "react"
import { Grid, Typography, TextField, Stack, Checkbox } from "@mui/material"
import { ValidateInt } from "../../../../../core/validator/Validator"
import { ToolContext } from "../../../../../core/context/ToolContext"

export const AnotherDetails = ({ classes, handleChange, handleStrToIntChange }) => {
    const { realproperty_state } = useContext(ToolContext);
    const { mainInfrmtn, dfltMainInfrmtn } = realproperty_state;

    const handleCbChange = (e) => {
        const { name, checked } = e.target;
        mainInfrmtn.set({
            ...mainInfrmtn.data,
            [name]: checked ? 1 : 0,
        })
    }

    const handlePriceChange = (e) => {
        const { name, value } = e.target;
        // to add comma
        let rawValue = value.replace(/,/g, ""); 
        let formattedValue = rawValue && !isNaN(rawValue) ? Number(rawValue).toLocaleString() : "";
        if (["price", "monthly", "yearly"].includes(name)) {
            const isValid = value !== "";
            mainInfrmtn.set({
                ...mainInfrmtn.data,
                [name]: {
                    ...mainInfrmtn.data[name],
                    value: formattedValue,
                    stat: !isValid,
                }
            })
        }
    }

    return (
         <>
            {/* 1 = Condominium, 2 = Commercial, 3 = Apartment, 4 = House, 5 = Land */}
            { [1,2,3,4].includes(mainInfrmtn.data.propertyType.value)  && 
                <Grid item xs={6}>
                    <Typography fontWeight={600} fontSize={14} mb="0.5rem">
                        {
                            mainInfrmtn.data.propertyType.value === 1 ? "Condominium Name" :
                            mainInfrmtn.data.propertyType.value === 2 ? "Building Name" : "Subdivision Name" 
                        }
                    </Typography>
                    <TextField 
                        name = {
                            mainInfrmtn.data.propertyType.value === 1 ? "condominiumName" :
                            mainInfrmtn.data.propertyType.value === 2 ? "buildingName" : "subdivisionName" 
                        }
                        value = { 
                            mainInfrmtn.data[
                                mainInfrmtn.data.propertyType.value === 1 ? "condominiumName" : 
                                mainInfrmtn.data.propertyType.value === 2 ? "buildingName" : "subdivisionName"
                            ]
                        } 
                        onChange={(e) => handleChange(e, mainInfrmtn)} variant="outlined" fullWidth size="small" className={classes.tf}/>
                </Grid>
            }
            { [1,2,3,4].includes(mainInfrmtn.data.propertyType.value) &&
                <Grid item xs={6}>
                    <Typography fontWeight={600} fontSize={14} mb="0.5rem">{mainInfrmtn.data.propertyType.value === 1 ? "Unit No / Floor No." : "Block and Lot/Unit/Floor No."}</Typography>
                    <TextField name={mainInfrmtn.data.propertyType.value === 1 ? "unitNoFloorNo" : "blockLotUnitFloorNo"} value={mainInfrmtn.data[
                            mainInfrmtn.data.propertyType.value === 1 ? "unitNoFloorNo" : "blockLotUnitFloorNo"
                        ]} onChange={(e) => handleChange(e, mainInfrmtn)} variant="outlined" fullWidth size="small" className={classes.tf}/>
                </Grid>
            }
            { (mainInfrmtn.data.propertyType.value === 1 || mainInfrmtn.data.propertyType.value === 4) &&
                <>
                    <Grid item xs={3}>
                        <Typography fontWeight={600} fontSize={14} mb="0.5rem" >Bedroom</Typography>
                        <TextField name="bedroom" value={mainInfrmtn.data.bedroom} onChange={handleStrToIntChange} fullWidth size="small" onKeyPress={ValidateInt} className={classes.tf}/>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography fontWeight={600} fontSize={14} mb="0.5rem" >Bathroom</Typography>
                        <TextField name="bathroom" value={mainInfrmtn.data.bathroom} onChange={handleStrToIntChange} fullWidth size="small" onKeyPress={ValidateInt} className={classes.tf}/>
                    </Grid>
                </>
            }
            { [1,2,3,4].includes(mainInfrmtn.data.propertyType.value) &&   
                <Grid item xs={3}>
                    <Typography fontWeight={600} fontSize={14} mb="0.5rem">Floor Area (m²)</Typography>
                    <TextField name="floorArea" value={mainInfrmtn.data.floorArea} onChange={handleStrToIntChange} fullWidth size="small" onKeyPress={ValidateInt} className={classes.tf}/>
                </Grid>
            }
            { [2,3,4,5].includes(mainInfrmtn.data.propertyType.value) &&  
                <Grid item xs={3}>
                    <Typography fontWeight={600} fontSize={14} mb="0.5rem">Land Size (m²)</Typography>
                    <TextField name="landSize" value={mainInfrmtn.data.landSize} onChange={handleStrToIntChange} fullWidth size="small" onKeyPress={ValidateInt} className={classes.tf}/>
                </Grid>
            }
            {mainInfrmtn.data.offerType.value === 1 &&
                <Grid item xs={12} display="flex" flexDirection="row">
                    <Stack width="100%" direction="row" alignItems="center">
                        <Checkbox name="forClosure" size="small" onChange={handleCbChange} checked={!!mainInfrmtn.data.forClosure} />
                        <Typography >For Foreclosure</Typography>
                    </Stack>
                    <Stack width="100%" direction="row" alignItems="center">
                        <Checkbox name="preSelling" size="small" onChange={handleCbChange} checked={!!mainInfrmtn.data.preSelling}/>
                        <Typography>For Pre-Selling</Typography>
                    </Stack>
                </Grid> 
            }
            {mainInfrmtn.data.offerType.value === 1 ?
                <Grid item xs={6}>
                    <Typography fontWeight={600} fontSize={14} mb="0.5rem">Price (&#8369;)
                        <Typography component="span" color="error">*</Typography>
                    </Typography>
                    <TextField name="price" value={mainInfrmtn.data.price.value} onChange={handlePriceChange} error={mainInfrmtn.data.price.stat} helperText={mainInfrmtn.data.price.stat ? dfltMainInfrmtn.data.price.msg : ""} fullWidth size="small" className={classes.tf} onKeyPress={ValidateInt}/>
                </Grid>
            :
                <>
                    <Grid item xs={6}>
                        <Typography fontWeight={600} fontSize={14} mb="0.5rem">Price per Month (&#8369;)
                            <Typography component="span" color="error">*</Typography>
                        </Typography>
                        <TextField name="monthly" value={mainInfrmtn.data.monthly.value} onChange={handlePriceChange} error={mainInfrmtn.data.monthly.stat} helperText={mainInfrmtn.data.monthly.stat ? dfltMainInfrmtn.data.monthly.msg : ""} fullWidth size="small" className={classes.tf} onKeyPress={ValidateInt}/>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography fontWeight={600} fontSize={14} mb="0.5rem">Price per Year (&#8369;)
                            <Typography component="span" color="error">*</Typography>
                        </Typography>
                        <TextField name="yearly" value={mainInfrmtn.data.yearly.value} onChange={handlePriceChange} error={mainInfrmtn.data.yearly.stat} helperText={mainInfrmtn.data.yearly.stat ? dfltMainInfrmtn.data.yearly.msg : ""} fullWidth size="small" className={classes.tf} onKeyPress={ValidateInt}/>
                    </Grid>
                </>
            }
            <Grid item xs={12}>
                <Stack direction="row" alignItems="center">
                    <Checkbox name="showPrice" size="small" onChange={handleCbChange} checked={!!mainInfrmtn.data.showPrice}/>
                    <Typography>Show Price Online</Typography>
                </Stack>
            </Grid>
            <Grid item xs={6}>
                <Typography fontWeight={600} fontSize={14} mb="0.5rem">Available From
                    <Typography component="span" color="error">*</Typography>
                </Typography>
                <TextField name="availableFrom" type="date" value={mainInfrmtn.data.availableFrom.value} onChange={(e) => handleChange(e, mainInfrmtn)} error={mainInfrmtn.data.availableFrom.stat} helperText={mainInfrmtn.data.availableFrom.stat ?  dfltMainInfrmtn.data.availableFrom.msg : ""} fullWidth size="small" className={classes.tf}
                    inputProps={{
                    min: new Date().toISOString().split("T")[0], // today's date in YYYY-MM-DD
                    }}
                />
            </Grid>
        </>
    )
}
